<template>
    <div class="ma-4">
      <v-snackbar v-model="msg" top>
        {{ text }}
        <v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar
      >
      <ClientNav />
      <v-row dense>
        <v-col cols="12" lg="3" xl="2">
          <ClientSide />
        </v-col>
        <v-col cols="12" lg="9" xl="10">
          <v-card class="pa-2" outlined tile height="100%">
          <v-data-table
            :headers="headers"
            :items="ancillaries"
            sort-by="StartDate"
            sort-desc
            :loading="isLoading"
            loading-text="Loading Ancillary"
            :search="search"
            height="550"
            
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Ancillary</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  clearable
                  @click:clear="callItBack()"
                  flat
                  solo-inverted
                  hide-details
                  prepend-inner-icon="search"
                  label="search"
                  class="desktop"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="100%">
                  <template v-slot:activator="{ on }">
                    <v-btn color="#2b3990" dark class="mb-2" v-on="on" @click="showAdd()"
                  >
                  <v-icon left>add</v-icon>
                  Add Ancillary</v-btn
                >
                  </template>
                  <v-card>
                    <v-card-title style="background-color: #2b3990">
                      <span class="headline white--text">{{ titleForm }}</span>
                    </v-card-title>
                    <v-card-text>
                      <v-form
                        ref="form"
                        lazy-validation
                      >
                      <v-container>
                        <v-row>
                            <v-col cols="12" md="4">
                              <v-menu
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                :return-value.sync="date"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="newDate"
                                    label="Date of Service"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="newDate"
                                  no-title
                                  scrollable
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="menu = false"
                                  >
                                    Cancel
                                  </v-btn>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.menu.save(newDate)"
                                  >
                                    OK
                                  </v-btn>
                                </v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="12" md="4">
                              <v-select
                                  label="Area of Protective Oversight"
                                  :items="oversights"
                                  v-model="newOversight"
                                  :rules="requiredField"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" v-if="newOversight == 'Other'">
                              <v-textarea
                                label="Other"
                                v-model="newOther"
                                outlined
                              ></v-textarea>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-select
                                    label="Time/Hours"
                                    v-model="newTime"
                                    :items="times"
                                    :rules="requiredField"
                                ></v-select>
                            </v-col>                 
                            
                        </v-row>
                      </v-container>
                      </v-form>
                    </v-card-text>
  
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        class="white--text"
                        color="#259647"
                        @click="addAncillary()"
                        v-if="newAncillary"
                        >Save</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="updateAncillary()"
                        v-if="editAncillary"
                        >Update</v-btn
                      >
                      <v-btn color="blue darken-1" text @click="close"
                        >Cancel</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
              <v-text-field
                v-model="search"
                clearable
                flat
                solo-inverted
                hide-details
                prepend-inner-icon="search"
                label="search"
                class="mobile ml-5 mr-5 mb-3 mt-3"
              ></v-text-field>
            </template>
  
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="viewAncillary(item)">
                mdi-eye
              </v-icon>
             
              <v-icon small @click="deleteAncillary(item)">
                mdi-delete
              </v-icon>
             
            </template>
            <template v-slot:no-data>
              <v-btn color="#2b3990" class="white--text" @click="getAncillaries()">Reset</v-btn>
            </template>
          </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <Foot />
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import ClientNav from "../../components/ClientNav";
  import ClientSide from "../../components/ClientSide";
  import Foot from "../../components/Footer";
  
  const url = require("../../client_config/config").url;
  
  export default {
    components: {
      ClientNav,
      ClientSide,
      Foot,
    },
    data: function() {
      return {
        headers: [
          {
            text: "Date",
            align: "start",
            sortable: false,
            value: "Date",
          },
          { text: "Oversight", value: "Oversight"},
          { text: "Time/Hours", value: "Time"},
          { text: "Actions", value: "actions", sortable: false },
        ],
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        dialog: false,
        editAncillary: false,
        newAncillary: false,
        msg: false,
        search: "",
        text: "",
        ancillaries: [],
        tempData: [],
        clientID: this.$route.params.clientID,
        titleForm: "New Ancillary Log",
        ancillaryID: "",
        newDate: "",
        newTime: "",
        newOversight: "",
        newOther: "",
        oversights: [
          "Medical",
          "Transportation",
          "Other",
        ],
        times: [
          .25,
          .50,
          .75,
          1.00,
          1.25,
          1.50,
          1.75,
          2.00,
          2.25,
          2.50,
          2.75,
          3.00,
          3.25,
          3.50,
          3.75,
          4.00,
          4.25,
          4.50,
          4.75,
          5.00,
          5.25,
          5.50,
          5.75,
          6.00,
          6.25,
          6.50,
          6.75,
          7.00,
          7.25,
          7.50,
          7.75,
          8.00,
          8.25,
          8.50,
          8.75,
          9.00,
          9.25,
          9.50,
          9.75,
          10.00,

        ],
        requiredField: [
            v => !!v || 'This is required',
        ],

        isLoading: true,
      };
    },
  
    computed: {
      formTitle() {
        return this.editedIndex != 1 ? "New Item" : "Edit Item";
      },
    },
  
    watch: {
      dialog(val) {
        val || this.close();
      },
    },
  
    created() {
      this.getAncillaries();
    },
  
    methods: {
      initialize() {
        this.ancillaries = [];
      },
      validate() {
          return this.$refs.form.validate();
      },
      viewAncillary(item) {
        this.titleForm = "Viewing Ancillary Log"
        this.dialog = true;
        this.editAncillary = true;
        this.newAncillary = false;
        this.newDate = item.Date;
        this.newTime = item.Time;
        this.newOversight = item.Oversight;
        this.newOther = item.Other;
        this.ancillaryID = item._id;
      },
      showAdd() {
        this.titleForm = "New Ancillary";
        this.newAncillary = true;
        this.editAncillary = false;
      },
  
      deleteAncillary(item) {
        const id = item._id;
        confirm("Are you sure you want to delete this ancillary log?") &&
          this.ancillaryDelete(id);
      },
  
      ancillaryDelete(id) {
        axios.delete(`${url}/ancillary/${id}`).then((response) => {
          this.getAncillaries();
          if (response.status == 400) {
            response.json().then(function(data) {
              return data.msg;
            });
          }
          this.msg = true;
          this.text = "The record has been deleted successfully.";
        });
      },
  
      close() {
        this.clear()
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
  
      updateAncillary() {
        var req_body = {
          Date: this.newDate,
          Time: this.newTime,
          Oversight: this.newOversight,
          Other: this.newOther,
        };
        axios
          .put(`${url}/ancillary/${this.ancillaryID}`, req_body)
          .then((response) => {
            this.getAncillary();
            if (response.status == 400) {
              response.json().then(function(data) {
                alert(data.msg);
              });
            }
            this.clear()
            this.msg = true;
            this.text = "The record has been updated successfully.";
          });
        this.close();
      },
      getAncillaries: function() {
        this.isLoading = true;
        this.ancillaries = [];
        axios.get(`${url}/ancillary/client/${this.clientID}`).then(res => {
          this.ancillaries = res.data.ancillaries
        })
        .finally(() => (this.isLoading = false));
      },
  
      addAncillary: function() {
        if(this.validate()){
          var req_body = {
            Date: this.newDate,
            Time: this.newTime,
            Oversight: this.newOversight,
            Other: this.newOther,
            ClientID: this.clientID,
          };
  
          axios.post(`${url}/ancillary`, req_body).then((res) => {
            this.getAncillaries();
            if (res.status == 400) {
              res.json().then(function(data) {
                this.msg=true;
                this.text = data.msg;
              });
            }
            this.clear()
            this.msg = true;
            this.text = "The new record has been added successfully.";
          });
          this.close();
      } else {
        this.msg = true;
        this.text="Please fill out all required fields"
      }
      },
  
      clear(){
        this.newDate = '';
        this.newTime = '';
        this.newOversight = '';
        this.newOther = "";
      },
  
    },
  };
  </script>
  <style>
  @media only screen and (min-width: 768px) {
    .mobile {
      display: none;
    }
  }
  
  @media only screen and (max-width: 600px) {
    .desktop {
      display: none;
    }
  }
  </style>
  